
import { Loader2 } from "lucide-react";

const LoadingState = () => {
  return (
    <div className="flex items-center justify-center h-full p-6 bg-pastel-blueLight dark:bg-[#121624]">
      <Loader2 className="h-8 w-8 animate-spin text-custom-primary dark:text-custom-secondaryLight mr-2" />
      <span className="text-custom-dark dark:text-gray-300 font-sans">Chargement des contenus...</span>
    </div>
  );
};

export default LoadingState;
